module.exports = __webpack_public_path__ + "resources/img/img_dvision1.40cf6b8a6097dff4831933470d26fc43.png";